import { render, staticRenderFns } from "./recognize-excel.vue?vue&type=template&id=226dda9d&scoped=true"
import script from "./recognize-excel.vue?vue&type=script&lang=ts"
export * from "./recognize-excel.vue?vue&type=script&lang=ts"
import style0 from "./recognize-excel.vue?vue&type=style&index=0&id=226dda9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226dda9d",
  null
  
)

export default component.exports